export default __webpack_public_path__ + "static/media/hero-change-password.ad02181b.svg";